import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { maskInput } from '../maskInput/index.js';
import { Input } from '../Input/index.js';

const MASK = '(ddd) ddd-dddd';
const MaskedInput = maskInput(MASK)(Input); // NOTE these are used to track inner-backspace event interactions
// that can frustrate users if you don't cover all above constants
// in their entirety in the following variable array passed in

const SKIP_DELETIONS = ['(', ') ', '-'];
const InputPhoneNumber = forwardRef(({
  label = 'Mobile phone number (optional)',
  maxlength,
  skipDeletions,
  ...props
}, ref) => jsx(MaskedInput, Object.assign({
  label: label,
  mask: MASK,
  maxlength: 14,
  skipDeletions: SKIP_DELETIONS
}, props, {
  childRef: ref
}), void 0));
InputPhoneNumber.displayName = 'InputPhoneNumber';

export { InputPhoneNumber };
